@if (credentialsValid()) {
	@if (loadingError$() | async; as loadingError) {
		<div class="operation-result-outer">
			<div class="operation-result error-color">
				<i class="ico ico-warning error-color"></i>
				@if (loadingError.error.title) {
					<div>
						<p>
							<span> {{ loadingError.error.title | translate }}:</span><br />
							<strong class="error-color">{{ loadingError.error.message }}</strong>
						</p>
						@if (loadingError.error.causes) {
							<div>
								@for (cause of loadingError.error.causes; track cause) {
									<p>
										<br />
										<span>{{ cause.name }}</span>
										@if (cause.name) {
											<span>:</span>
										}
										<br />
										<strong class="error-color">{{ cause.message }}</strong>
									</p>
								}
							</div>
						}
					</div>
				}
				@if (!loadingError.error.title) {
					<div>
						<p>
							<span translate="error.general.title"></span><br />
							<strong class="error-color" translate="error.general.message"></strong>
						</p>
					</div>
				}
			</div>
		</div>
	} @else {
		<stages-spin [size]="'sm'" />
	}
}
